// extracted by mini-css-extract-plugin
export default {"fr-view":"AccountVerification_fr-view__0Wmyb","error":"AccountVerification_error__4ZCfQ","field":"AccountVerification_field__QSIB-","action":"AccountVerification_action__UWO6I"};